export const firebaseConfig = {
  apiKey: "AIzaSyBAjwUEJB1ek6SIlLPOJbS2_BPB4wjVQbw",
  authDomain: "my-profile-aaad6.firebaseapp.com",
  projectId: "my-profile-aaad6",
  storageBucket: "my-profile-aaad6.firebasestorage.app",
  messagingSenderId: "218757697403",
  appId: "1:218757697403:web:547aac9aaee4b24c42b7de",
  measurementId: "G-VQY471KE9P",
  REACT_APP_FIREBASE_API_KEY: "AIzaSyBAjwUEJB1ek6SIlLPOJbS2_BPB4wjVQbw",
  REACT_APP_FIREBASE_AUTH_DOMAIN: "my-profile-aaad6.firebaseapp.com",
  REACT_APP_FIREBASE_PROJECT_ID: "my-profile-aaad6",
  REACT_APP_FIREBASE_STORAGE_BUCKET: "my-profile-aaad6.firebasestorage.app",
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: "218757697403",
  REACT_APP_FIREBASE_APP_ID: "1:218757697403:web:547aac9aaee4b24c42b7de",
};
